module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAATCAYAAABlcqYFAAAACXBIWXMAAAsSAAALEgHS3X78AAAARElEQVQ4EWNM42H4z0BbcIAFZLwLFxNNbHn/j4Hh7I9/DLQxHQ2MWjJqyaglo5aMWoID0MUScH2y59s/ethFQ8DAwAAAkb0KCX/4Aq0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-red-b-1.png
// module id = 248
// module chunks = 0